module.exports = __webpack_public_path__ + "img/agiel-untitled.21e3067.jpg";